<template>
  <modal-dialog
    v-bind:content-class="customClass"
    v-bind:title="title"
    v-bind:value="value"
    v-on:input="onInput"
    with-cross
    max-width="90%"
    v-bind:width="width"
  >
    <template v-slot:header>
      <slot name="header" />
      <input-text-search
        v-if="showSearchBlock"
        class="modal-dialog__input-text-search"
        placeholder="Введите название"
        v-model="searchQuery"
      />
    </template>
    <form class="picker" v-on:submit.prevent>
      <div class="picker__items">
        <span
          v-for="(item, index) in items"
          v-bind:key="index"
          class="picker__item"
        >
          <slot
            v-bind="{
              item,
              emitAdd,
              onSelectSetColor,
            }"
          />
        </span>
      </div>
    </form>
    <slot name="bottom" />
  </modal-dialog>
</template>

<script>
import ModalDialog from '@/components/ModalDialog.vue';
import InputTextSearch from '@/components/InputTextSearch.vue';
import debounce from 'lodash.debounce';

/**
 * @description Название события добавления.
 * @type {string}
 */
const NAME_EVENT_ADD = 'add';

/**
 * @description Название события поиска.
 * @type {string}
 */
const NAME_EVENT_SEARCH = 'search';

/**
 * @description Название события ввода.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

/**
 * @description Название события открытия.
 * @type {string}
 */
const NAME_EVENT_OPEN = 'open';

/**
 * @description Выбор услуг из прайса.
 * @type {Vue}
 */
export default {
  components: {
    InputTextSearch,
    ModalDialog,
  },
  computed: {
    /**
     * @description Определить кастомный набор классов.
     */
    customClass() {
      const positionStartClass = this.positionStart ? 'position-start' : '';
      return [this.contentClass, positionStartClass].join(' ').trim();
    },
  },
  methods: {
    /**
     * @description Отправить событие добавления.
     * @param {Object} item
     * @returns {void}
     */
    emitAdd(item) {
      this.$emit(NAME_EVENT_ADD, item);
    },
    /**
     * @description Обработать показ окна.
     * @param {boolean} isShown Показывать.
     * @returns {void}
     */
    onInput(isShown) {
      this.$emit(NAME_EVENT_INPUT, isShown);
    },
    /**
     * @description Изменить цвет выбранного элемента на синий.
     * @param {Object} evt     Событие.
     * @returns {void}
     */
    onSelectSetColor(evt) {
      const currentItem = evt.target;
      currentItem.classList.add('selected');
    },
    /**
     * @description Сбросить активный цвет удаленного элемента.
     * @param {String} selector  Селектор элемента.
     * @returns {void}
     */
    onRemoveActiveColor(selector) {
      const deletedElem = document.querySelector(selector);
      if (deletedElem) {
        deletedElem?.classList.remove('selected');
      }
    },
  },
  data() {
    return {
      panel: undefined,
      searchQuery: '',
    };
  },
  name: 'PickerItems',
  props: {
    /**
     * @description Пользовательский класс.
     * @type {String}
     */
    contentClass: { default: '', type: String },
    /**
     * @description Выранивание модального окна по верхнему краю относительно поперечной оси.
     * @type {Boolean}
     */
    positionStart: { default: false, type: Boolean },
    /**
     * @description Ширина модального окна.
     * @type {String}
     */
    width: { default: '700px', type: String },
    /**
     * @description Список элементов.
     * @type {Array}
     */
    items: { required: true, type: Array },
    value: { required: true, type: Boolean },
    title: { default: () => '', type: String },
    showSearchBlock: { default: () => true, Boolean },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.panel = undefined;
        this.$emit(NAME_EVENT_OPEN, this.onRemoveActiveColor);
      }
    },
    searchQuery: {
      handler: debounce(function update(value) {
        this.$emit(NAME_EVENT_SEARCH, value);
      }, 300),
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";

.modal-dialog {
  &__input-text-search {
    width: 100%;
  }
}

.picker {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1000px;
  gap: 15px;
  margin: 10px 0;
  &__actions {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 15px;
    margin: 10px 0 0 0;
  }
  &__buttons {
    column-gap: 9px;
    display: grid;
    grid-template-columns: 180px 180px;
    &-submit {
      @include buttons.btn-blue(100%, 48px, 16px);
    }
    &-submit:disabled {
      background-color: var(--unfocus-color);
    }
    &-cancel {
      @include buttons.btn-transparent(100%, 48px, 16px);
    }
  }
  &__items {
    display: flex;
    flex-direction: column;
    gap: 10px;
    list-style: none;
    padding-left: 0 !important;
  }
  &__item {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-gap: 5px;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    &__button {
      max-width: 400px;
      text-align: left;
      transition: color 0.2s;
      > span.selected {
        color: #0569ac;
      }
      @media (hover: hover) {
        &:hover {
          color: #0076C4;
        }
      }
      &:active {
        color: #0569ac;
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .picker {
    &__buttons {
      grid-template-columns: 1fr;
      grid-gap: 10px;
    }
  }
}
</style>
